import React from 'react'
import { Outlet } from 'react-router-dom'

const Visit = () => {
  return (
    <Outlet/>
  )
}

export default Visit